import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Table,
  Input,
  Button,
  Space,
  PageHeader,
  Breadcrumb,
  Tag,
  DatePicker,
  Select,
  Row,
  Col,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import { EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { getCode } from "../../actions/code";
import { Link } from "react-router-dom";
import history from "../../history";
import { connect } from "react-redux";
import { Pagination } from "antd";
import EditScanlimit from "./EditScanLimit";
import EditLocLimit from "./EditLocLimit";
const { RangePicker } = DatePicker;
const { Option } = Select;
class CodeCMList extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    data: [],
    serviceDetails: null,
    detail: false,
    visible: false,
    passVisible: false,
    locVisible: false,
    modalVisible: false,
    editModalVisible: false,
    placement: "bottom",
    id: "",
    bo: null,
    c: null,
    e: null,
    ds: null,
    de: null,
    b: null,
    p: 1,
    current: 1,
  };
  componentDidMount = async () => {
    const res = await this.props.getCode(
      this.state.p,
      this.state.e,
      this.state.bo,
      this.state.b,
      this.state.ds,
      this.state.de,
      this.state.c
    );
    this.setState({ data: res });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  createData = (
    sl,
    code_id,
    product_name,
    product_thumbnail,
    dif_location_count,
    dif_location_limit,
    scan_count,
    scan_limit,
    block,

    action
  ) => {
    return {
      sl,
      code_id,
      product_name,
      product_thumbnail,
      dif_location_count,
      dif_location_limit,
      scan_count,
      scan_limit,
      block,

      action,
    };
  };

  showDrawer = (id) => {
    this.setState({
      visible: true,
      id: id,
    });
  };
  handleRefresh = async () => {
    const res = await this.props.getCode();
    this.setState({ data: res });
  };

  handlePassVisible = (id) => {
    this.setState({ passVisible: true, id: id });
  };
  handleModalVisible = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };
  handleVisible = async (code_id) => {
    history.push(`/code-details?code=${encodeURIComponent(code_id)}`);
  };
  handleEditModalVisible = (code_id) => {
    this.setState({
      editModalVisible: !this.state.editModalVisible,
      id: code_id,
    });
  };
  handleEditLocVisible = (code_id) => {
    this.setState({
      locVisible: !this.state.locVisible,
      id: code_id,
    });
  };
  onClosePass = () => {
    this.setState({
      passVisible: false,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  makeLocalTime = (date) => {
    let mainDate = date.split("T")[0];
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      mainDate + " , " + hours + ":" + minutes + " " + (am ? "a.m" : "p.m")
    );
  };
  handleDate = (date) => {
    if (date) {
      const ds = new Date(date[0]._d);
      const de = new Date(date[1]._d);
      this.setState({ ds: ds.toISOString(), de: de.toISOString() });
    } else {
      this.setState({ ds: null, de: null });
      return;
    }
  };
  handlePageChange = async (page) => {
    const res = await this.props.getCode(
      page,
      this.state.e,
      this.state.bo,
      this.state.b,
      this.state.ds,
      this.state.de,
      this.state.c
    );
    this.setState({ current: page, data: res });
  };
  handleApiSearch = async () => {
    const res = await this.props.getCode(
      this.state.p,
      this.state.e,
      this.state.bo,
      this.state.b,
      this.state.ds,
      this.state.de,
      this.state.c
    );
    this.setState({ data: res });
  };

  render() {
    const columns = [
      {
        title: "SL",
        dataIndex: "sl",
        key: "sl",
        width: "10%",
      },
      {
        title: "CODE ID",
        dataIndex: "code_id",
        key: "code_id",
        width: "20%",
        ...this.getColumnSearchProps("code_id"),
      },
      {
        title: "Product name",
        dataIndex: "product_name",
        key: "product_name",
        width: "15%",
      },
      {
        title: "Location Count",
        dataIndex: "dif_location_count",
        key: "dif_location_count",
        width: "15%",
      },
      {
        title: "Location Limit",
        dataIndex: "dif_location_limit",
        key: "dif_location_limit",
        width: "15%",
      },
      {
        title: "Total Scaned ",
        dataIndex: "scan_count",
        key: "scan_count",
        width: "15%",
        ...this.getColumnSearchProps("scan_count"),
      },
      {
        title: "Scaned Limit",
        dataIndex: "scan_limit",
        key: "scan_limit",
        width: "15%",
        ...this.getColumnSearchProps("scan_limit"),
      },

      {
        title: "Status",
        dataIndex: "block",
        key: "block",
        width: "15%",
        ...this.getColumnSearchProps("block"),
      },

      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: "25%",
      },
    ];
    const { data } = this.state;
    const rows = [
      data?.batch
        ? data?.batch.map((item, id) =>
            this.createData(
              id + 1,
              item?.code_id,
              item?.product_name,
              item?.product_name,
              item?.dif_location_count,
              <>
                {item?.dif_location_limit} &nbsp;
                <Button
                  size="small"
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={() => this.handleEditLocVisible(item.code_id)}
                ></Button>
              </>
              ,
              item?.scan_count,
              <>
                {item?.scan_limit} &nbsp;
                <Button
                  size="small"
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={() => this.handleEditModalVisible(item.code_id)}
                ></Button>
              </>,
              <>
                {item?.block ? (
                  <Tag color="#e65907">&nbsp;Blocked&nbsp;</Tag>
                ) : (
                  <Tag color="#06bb1e">&nbsp;Active&nbsp;</Tag>
                )}
              </>,

              <Button
                size="small"
                type="primary"
                icon={<EyeOutlined />}
                onClick={() => this.handleVisible(item?.code_id)}
              >
                View
              </Button>
              //   {/* <Button size="small" type="primary" icon={<EditOutlined  />} onClick={() => this.handleEditModalVisible(item.order_id)}>Edit</Button> &nbsp; */}
              //   {/* <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => this.showDrawer(item.order_id)}><Button size="small" type="danger" icon={<DeleteOutlined  />}>Delete</Button></Popconfirm> */}

              // </>
            )
          )
        : "",
    ];
    return (
      <Content>
        <Breadcrumb style={{ padding: "10px 0px" }}>
          <Breadcrumb.Item>
            <Link to="/dashboard">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Code List</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Code List"
          subTitle="Code Management"
          extra={
            <Tag color="#2db7f5" style={{ fontSize: "15px", padding: "4px" }}>
              {" "}
              {data?.count} data found
            </Tag>
          }
        ></PageHeader>
        <br />
        <Row>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Client Email"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ e: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Code Id"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ c: e.target.value })}
            />
          </Col>
          <br />
          <br />
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Batch Id"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ b: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select a status"
              name="status"
              optionFilterProp="children"
              onChange={(e) => this.setState({ bo: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>

              <Option value="active">Active</Option>
              <Option value="blocked">Blocked</Option>
            </Select>
          </Col>

          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <RangePicker
              onChange={this.handleDate}
              format="YYYY/MM/DD"
              style={{ width: "80%" }}
            />
            &nbsp; &nbsp;
            <Tooltip title="search" onClick={this.handleApiSearch}>
              <Button type="primary" shape="circle" icon={<SearchOutlined />} />
            </Tooltip>
          </Col>
        </Row>
        <br />

        <Table
          columns={columns}
          dataSource={rows[0]}
          scroll={{ x: 1000 }}
          sticky
          pagination={false}
        />
        <Pagination
          current={this.state.current}
          total={data?.count}
          pageSize="20"
          onChange={this.handlePageChange}
          pageSizeOptions={[20]}
        />
       
        {this.state.editModalVisible ? (
          <EditScanlimit
            visible={this.state.editModalVisible}
            setVisible={this.handleEditModalVisible}
            code_id={this.state.id}
            refresh={this.handleRefresh}
          />
        ) : null}
       
        {this.state.locVisible ? (
          <EditLocLimit
            visible={this.state.locVisible}
            setVisible={this.handleEditLocVisible}
            code_id={this.state.id}
            refresh={this.handleRefresh}
          />
        ) : null}
      </Content>
    );
  }
}

export default connect(null, { getCode })(CodeCMList);
